module.exports = __webpack_public_path__ + "static/media/title-back.6f79b2b7.png";